import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import WhatIsSection from "./components/WhatIsSection";
import CTASection from "./components/CTASection";
import AllCategories from "./components/AllCategories";
import ArticlePreview from "./components/ArticlePreview";
import ArticleGrid from "./components/ArticleGrid";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://pandabuy.guru";
const faviconUrl = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      "url": siteUrl,
      "name": "Pandabuy.guru",
      "description": "Discover the best pandabuy spreadsheet collections updated weekly. Browse curated streetwear, sneakers, hoodies, and accessory finds.",
      "publisher": {
        "@type": "Organization",
        "@id": `${siteUrl}/#organization`,
        "name": "Pandabuy.guru",
        "url": siteUrl,
        "logo": {
          "@type": "ImageObject",
          "url": faviconUrl,
        },
      },
      "inLanguage": "en",
    },
    {
      "@type": "WebPage",
      "@id": `${siteUrl}/#webpage`,
      "url": siteUrl,
      "name": "Best Pandabuy Spreadsheet 2026 — Curated Finds & Verified Lists",
      "description": "Discover the best pandabuy spreadsheet collections updated weekly. Browse curated streetwear, sneakers, hoodies, and accessory finds. Organized, searchable, and SEO-optimized pandabuy spreadsheet database with beginner guides and safety tips.",
      "isPartOf": { "@id": `${siteUrl}/#website` },
      "about": { "@id": `${siteUrl}/#organization` },
      "inLanguage": "en",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": siteUrl,
          },
        ],
      },
    },
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen">
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <ArticlePreview />
      <WhatIsSection />
      <CTASection />
      <AllCategories />
      <ArticleGrid />
      <FAQ />
      <Footer />
    </main>
  );
}